<template>
<div class="d-flex min-vh-100">
    <CContainer fluid>
        <CCard
            accentColor='#122efe'
            align='center'
        >
            <CCardHeader class='d-flex justify-content-between'>
                <div class="d-flex align-items-baseline">
                    <CIcon name="cil-cart" size="xl" class='mr-2' />
                    <h3 class='m-0 font-weight-bold'>
                        Ordenes
                    </h3>
                </div>
                <CButton 
                    shape='square' 
                    color='info'
                    @click="$router.push('ordenes/crear')"
                    v-if='userIsPetitioner || userIsAdmin'
                    >
                Crear Orden &nbsp; <CIcon name='cil-plus' style="fill: white; stroke: 2px;"/> 
                </CButton>
            </CCardHeader>
            <CCardBody>
                <CRow>
                    <CCol sm='3'>
                        <CInput placeholder='Buscar...' v-model='filter' >
                            <template #append-content>
                                <CIcon size='sm' name='cil-magnifying-glass'/>
                            </template>
                        </CInput>
                    </CCol>
                    <CCol sm='2'>
                        <CSelect 
                            ref='filter-status'
                            :options='statuses'
                            :key='filterKeys.status.key + filterKeys.status.value'
                            placeholder='Filtrar por Estado...' 
                            @change="applyFilter('status', $event)"
                            />
                    </CCol>
                    <CCol sm='2'>
                        <CSelect 
                            ref='filter-priority'
                            :options='priorities' 
                            :key='filterKeys.priority.key + filterKeys.priority.value'
                            placeholder='Filtrar por Prioridad...' 
                            @change="applyFilter('priority', $event)"
                        />
                    </CCol>
                    <CCol sm='2'>
                        <CSelect 
                            ref='filter-department'
                            :options='departments'
                            :key='filterKeys.department.key + filterKeys.department.value'
                            placeholder='Filtrar por Sector...' 
                            @change="applyFilter('department', $event)"
                        />
                    </CCol>
                    <CCol sm='2'>
                        <CSelect 
                            ref='filter-scheduled_order'
                            :options='scheduled_orders_status'
                            :key='filterKeys.scheduled_order.key + filterKeys.scheduled_order.value'
                            placeholder='Filtrar por Tipo...' 
                            @change="applyFilter('scheduled_order', $event)"
                        />
                    </CCol>
                    <CCol sm='1'>

                        <CButton 
                            v-c-tooltip='"Quitar filtros"'
                            color='danger'
                            size='sm'
                            @click='clearFilters'>
                            <CIcon name='cil-trash' />
                        </CButton>
                    </CCol>
                </CRow>
                <CRow class='justify-content-center'>
                    <div class="responsive-datatables">
                        <datatable
                            class='table datatable'
                            :columns='tableFields'
                            :data='filteredRows'
                            :filter='filter'
                            ref="datatable"
                            :per-page='10'
                        >
                            <template slot-scope="{ row }">
                                <tr class='table-row'>
                                    <td>{{parseInt(row.id)}}</td>
                                    <td class='description-column'>{{ row.description ? row.description.text : '-'}}</td>
                                    <td>{{row.status.name}}</td>
                                    <td>{{row.priority.name}}</td>
                                    <td>{{row.department.name}}</td>
                                    <td>{{row.scheduled_order ? 'Automática' : 'Normal'}}</td>
                                    <td>
                                        <CButton
                                            class="mr-xl-1 messages-button"
                                            v-c-tooltip='"Historial de mensajes"'
                                            @click="setOrderMessages(row.id, row)"
                                            size='sm'

                                        >
                                            <CIcon name='cil-envelope-closed' size='sm'/>
                                        </CButton>
                                        <CButton 
                                            class='mr-xl-1'
                                            v-c-tooltip='"Recibir orden"'
                                            color='success'
                                            size='sm'
                                            @click='setDeliveredOrder(row.id)'
                                            v-if='userIsReceiver && (row.status.id == 5 || row.status.id == 9)'
                                        >
                                            <CIcon name='cil-check' size='sm'/>
                                        </CButton>
                                        <CButton
                                            class='mr-xl-1'
                                            v-c-tooltip='"Recibir Orden"'
                                            color='success'
                                            size='sm'
                                            @click='setReceivedOrder(row.id)'
                                            v-if='(userIsPetitioner || userIsAdmin) && (row.status.id == 6 || row.status.id == 7)'>
                                            <CIcon name='cil-check' size='sm' />
                                            </CButton>
                                        <CButton
                                            class='mr-xl-1'
                                            v-c-tooltip='"Comprar"'
                                            color='success'
                                            size='sm'
                                            @click='setBuyedOrder(row.id)'
                                            v-if='userIsBuyer && (row.status.id == 2 || row.status.id == 4)'>
                                            <CIcon name='cil-cart' size='sm'/>
                                        </CButton>
                                        <CButton
                                            class='mr-xl-1'
                                            v-c-tooltip='"Ver Orden"'
                                            color='info'
                                            size='sm'
                                            @click="getOrder(row.id)"
                                        >
                                            <CIcon name='cil-magnifying-glass' size='sm'/>
                                        </CButton>
                                        <CButton
                                            v-c-tooltip='"Modificar Orden"'
                                            color='warning'
                                            size='sm'
                                            @click="updateOrder(row.id)"
                                            v-if='(userIsAdmin || userIsApprover) && (row.status.id == 1)'
                                        >
                                            <CIcon name='cil-pencil' size='sm' />
                                        </CButton>
                                        
                                    </td>
                                </tr>
                            </template>
                        </datatable>
                        <div class="paginator-container">
                       
                            <datatable-pager v-model="page" class='paginator' type='short'>    
                            </datatable-pager>

                        </div>
        
                    </div>
                </CRow>
            </CCardBody>
        </CCard>

  
  </CContainer>
  <CContainer fluid class='order-modal-backdrop' v-if='showOrder || receiveOrder || buyOrder || messagesModal'>
        <CRow class='order-modal-row' v-if='showOrder || receiveOrder || buyOrder || messagesModal' >
            <CCol class='order-modal-container'>
                <OrderMessagesModal class='order-modal' :order='showedMessagesOrder' :order_id='showedMessagesOrderId' v-if='messagesModal && showedMessagesOrder && showedMessagesOrderId'/>
                <DeliveredOrderModal class='order-modal' :order='receivedOrder' v-else-if='receiveOrder && receivedOrder' />
                <BuyedOrderModal class='order-modal' :order='buyedOrder' v-else-if="buyOrder && buyedOrder"/>
                <OrderModal class='order-modal' :order='orderShowed' v-else-if='showOrder && orderShowed'/>
                
            </CCol>
        </CRow>
        
  </CContainer>
  </div>
</template>

<script>
import OrderModal from '../../components/OrderModal';
import DeliveredOrderModal from '../../components/DeliveredOrderModal';
import BuyedOrderModal from '../../components/BuyedOrderModal.vue';
import OrderMessagesModal from '../../components/OrderMessagesModal.vue';

import axios from 'axios';


export default {
    components: {
        OrderModal,
        DeliveredOrderModal,
        BuyedOrderModal,
        OrderMessagesModal
    },
    name: 'Ordenes',
    data(){
        return {
            row: 10,
            page: 1,
            filter: '',
            tableFields: [
                {label: 'ID',               field: 'id',                filterable: false},
                {label: 'Descripción',      field: 'description',       representedAs: (row) => row.description.text},
                {label: "Estado",           field: 'status',            representedAs: (row) => row.status.id},
                {label: "Prioridad",        field: 'priority',          representedAs: (row) => row.priority.id},
                {label: "Sector",           field: 'department',        representedAs: (row) => row.department.id},
                {label: "Tipo de orden",    field: 'scheduled_order',   representedAs: (row) => row.scheduled_order},
                {label: "Acciones",         field: 'actions',           filterable: false, orderable: false}
            ],
            ordersData: [],
            showOrder: false,
            //Mensajes de orden
            showedMessagesOrder: null,
            showedMessagesOrderId: null,
            messagesModal: false,
            // Orden Recibida
            receiveOrder: false,
            receivedOrder: {},

            // Orden Comprada

            buyOrder: false,
            buyedOrder: {},
            orderShowed: {},
            filters: [],
            // Datos para los selects
            departments: [],
            priorities: [],
            statuses: [],
            // Estado de los selects (para limpiar el filtro)
            filterKeys: {
                department: {
                    key: 'department-filter-',
                    value: 1
                },
                priority: {
                    key: 'priority-filter-',
                    value: 1
                },
                status: {
                    key: 'status-filter-',
                    value: 1
                },
                scheduled_order: {
                    key: 'scheduled_order-filter-',
                    value: 1
                }
            },
            scheduled_orders_status: [
                {value: 0, label: 'Normal'},
                {value: 1, label: 'Automática'}
            ]
        }
    },
    created(){
        this.getExternalData();
        this.getOrdersData();
    },
    mounted(){
        let me = this;
        
        this.$root.$on('close-modal', () => {
            me.closeOrderModal();
        })
        this.$root.$on(['delivered-order', 'buyed-order'], () => {
            me.closeOrderModal();
            me.$swal.fire({
                title: '¡Éxito!',
                text: 'La orden ha sido actualizada correctamente.',
                icon: 'success',
            }).then(() => {
                me.getOrdersData();
            })
        })
       
    },
    methods: {
        getOrdersData(){
            let me = this;
            return this.$api.orders.index().then(res => me.ordersData = res.data.data);
        },
        getExternalData(){
            let me = this;
            let request_1 = me.$api.departments.index();
            let request_2 = me.$api.priorities.index();
            let request_3 = me.$api.statuses.index();
            axios.all([request_1, request_2, request_3])
            .then(axios.spread((response_1, response_2, response_3) => {
                me.departments = [];
                me.departments = response_1.data.data.map(item => {
                    return {
                        value: item.id,
                        label: item.name
                    }
                });

                me.priorities = [];
                me.priorities = response_2.data.data.map(item => {
                    return {
                        value: item.id,
                        label: item.name
                    }
                });

                me.statuses = [];
                me.statuses = response_3.data.data.map(item => {
                    return {
                        value: item.id,
                        label: item.name
                    }
                })
            }))
            .catch(error => {
                console.log(error);
                console.log(error.response);
            });
        },
        updateOrder(id){
            this.$router.push({ path: `ordenes/modificar/${id}`});
        },
        getOrder(id){
            this.$api.orders.show(id)
            .then(res => {
                this.orderShowed = res.data.data[0];
                this.showOrder = true;
            })
            .catch(error => {
                console.log(error)

            })
            // Ver que onda como ve el user una orden. idealmente sería un modal.
        },
        closeOrderModal(){
            this.showOrder = false;
            this.receiveOrder = false;
            this.buyOrder = false;
            this.messagesModal = false;
        },
        applyFilter(column_name, event){
            
           let filterAppliedIndex = this.filters.findIndex(filter => filter.column === column_name);
            
            // Si ya hay aplicado un filtro, solo actualizamos el valor
           if (filterAppliedIndex >= 0 ){
               this.filters[filterAppliedIndex].value = event.target.value;
           } else {
               this.filters.push({
                   column: column_name,
                   value: event.target.value
               })
           }
        },
        clearFilters(){
            this.filterKeys.status.key += 1;
            this.filterKeys.department.key += 1;
            this.filterKeys.priority.key += 1;   
            this.filterKeys.scheduled_order.key += 1;
            this.filters = [];
        },
        shouldReturn(row){
            let checks = []; // false x default

            this.filters.forEach(filter => {    // Por cada una de las entradas en filters
                let value = filter.value;
                let column = filter.column;

                // Hotfix, god forbids me
                if(column !== 'scheduled_order'){
                    if(row[column] && parseInt(row[column].id) === parseInt(value)){
                    
                    checks.push(true);
                    } else {
                      
                        checks.push(false);
                    }
                } else {
                    console.log(row[column])
                    if((row[column] && value == 1) || (!row[column] && value == 0)){
                        checks.push(true)
                    } else {
                        checks.push(false)
                    }
                }
            });
            let shouldReturn = checks.indexOf(false) === -1 ? true : false;
            return shouldReturn;
        },
        setBuyedOrder(order_id){
            this.$api.orders.show(order_id)
            .then(res => {
                this.buyedOrder = res.data.data[0];
                this.buyOrder = true;
            })
            .catch(error => {
                console.log(error)

            })
        },
        setReceivedOrder(order_id){

              let me = this;
            this.$swal.fire({
                titleText: "Está seguro?",
                text: "Está seguro de confirmar la orden como recibida? Esta acción no se puede deshacer",
                icon: "warning",
                showConfirmButton: true,
                showCancelButton: true,
                confirmButtonText: "Confirmar",
                cancelButtonText: "Cancelar"
            }).then(result => {
                // Si el user puso ok
                if(result.isConfirmed){
                        // Llamamos a la api para pasarla a comprada
                        let body = {order_id: order_id}
                        me.$api.orders.setReceivedOrder(body)
                        .then(res => {
                        me.$swal.fire({
                             titleText: "¡Excelente!",
                             text: res.message ?? "Orden actualizada exitosamente",
                             icon: "success"
                         }).then(result => {
                             this.getOrdersData();
                            });
                        })
                        .catch(error => {
                          // Si tenemos un error, llamamos al modal de error
                        console.log(error);
                            if(error){
                                this.$swal.fire({
                                titleText: "Algo salió mal",
                                text: error.response ? error.response.message : "Error al actualizar",
                                icon: "error"
                            });
                        }
                    })
                }
            }) 
        },
        setDeliveredOrder(order_id){
             this.$api.orders.show(order_id)
            .then(res => {
                this.receivedOrder = res.data.data[0];
                this.receiveOrder = true;
            })
            .catch(error => {
                console.log(error)

            })
        },
        setOrderMessages(order_id, row){
                this.showedMessagesOrderId = order_id;
                this.showedMessagesOrder = row;
                this.messagesModal = true;
        },
        // Al que le toque mantener este código, mis sinceras disculpas, son las 5:33 AM del míercoles.
        getOrderDescription(row){
            switch(row.status.id){
                case 5: {
                    if(row.buyed_order_description && typeof row.buyed_order_description === 'object'){
                        return row.buyed_order_description.description
                    } else {
                        return row.description.text
                    }
                }
                case 6: {
                    if(typeof row.delivered_order_description === 'object'){
                        return row.delivered_order_description.description
                    } else if (typeof row.buyed_order_description === 'object'){
                        return row.buyed_order_description.description
                    } else {
                        return row.description.text
                    }
                }
                case 7: {
                    if(typeof row.delivered_order_description === 'object'){
                        return row.delivered_order_description.description
                    } else if (typeof row.buyed_order_description === 'object'){
                        return row.buyed_order_description.description
                    } else {
                        return row.description.text
                    }
                }
                default: {
                    return row.description.text
                }
               
            }
           // row.description && row.status.id == 1 ? row.description.text : row.status_description
        }

    },
    computed: {
        // Roles harcodeados, ver que onda.
        userIsAdmin(){
            return this.$store.state.user.role_id === 1;
        },
        userIsPetitioner(){
            return this.$store.state.user.role_id === 2;
        },
        userIsApprover(){
            return this.$store.state.user.role_id === 3;
        },
        userIsBuyer(){
            return this.$store.state.user.role_id === 4;
        },
        userIsReceiver(){
            return this.$store.state.user.role_id === 5;
        },
        filteredRows(){
            if (this.filters.length === 0 ){
                return this.ordersData;
            } else {
                return this.ordersData.filter(this.shouldReturn);
            }
        }
    },
    watch: {
        filters: function (newVal, oldVal) {
            this.filteredRows;
        }
    }
}
</script>

<style scoped lang='scss'>

.order-modal-backdrop{
     position: fixed;
     z-index: 5000;
    top: 50%;
    left: 50%;
    width: 100vw;
    height: 100vh;
    transform: translate(-50%, -50%);
    background-color: rgba(0, 0, 0, 0.5);
}
.order-modal-container{
    display: flex;
}
.order-modal-row{
    height: 100vh;
}
.order-modal{
    margin: auto;
    width: max-content;
    position: relative;
    z-index: 5001;
    @media screen and (min-width: 768px){
        width: 100%;
        max-width: 700px;
    }
    &.messages-modal{
        @media screen and (min-width: 768px){
            max-width: 950px;
        }
    }
}

.paginator-container{
    display: flex;
    align-items: center;
    justify-content: center;
    .paginator-button{
        padding: 0.5rem 0.875rem;
        border: solid 1px #3c4b64;
        border-radius: 2px;
    }
}

.messages-button{
    background-color: silver;
    border-color: silver;
    color:white;
}

</style>

